/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const EMPTY_SCREEN_TEXT = 'No sub-realms to display';
export const SEARCH = 'Search';
export const FOR = 'for';
export const ADD_LOCATION = 'Add Sub-Realm';
export const DELETE_LOCATION_CONTENT = 'Are you sure you want to delete sub-realm ';
export const CANCEL = 'Cancel';
export const ADD = 'Add';
export const pageNumber: number = 1;
export const pageSize: number = 50;
export const ASC = 'ASC';
export const PASSWORD_POLICY = 'Password Policy';
export const ERROR_MESSAGE_GENERAL = 'Something went wrong';

/** Replace interfaces to models folder **/
export interface ILocations {}
export interface IPage {
    pageNumber: number;
    pageSize: number;
    totalCount?: number,
    sortBy?: string;
    filterByLocationType?: string;
    filterByLocationName?: string;
}
export const pageData: IPage = {
    pageNumber,
    pageSize
};

export const fakeLocations = Array(60)
  .fill(undefined)
  .map((_value, index) => ({
    id: index + 1,
    name: `WH_${Math.floor(Math.random() * 9999) + 1}`,
    locationType: 'Warehouse',
    locationAddress: 'Dallas, TX',
    realmId: ''
  }));